var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-twitter",
    "data-name": "001-twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20.313,
    viewBox: "0 0 25 20.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M25,50.4a10.686,10.686,0,0,1-2.953.809A5.1,5.1,0,0,0,24.3,48.381a10.242,10.242,0,0,1-3.25,1.241,5.125,5.125,0,0,0-8.866,3.5A5.277,5.277,0,0,0,12.3,54.3,14.507,14.507,0,0,1,1.741,48.934a5.127,5.127,0,0,0,1.575,6.85A5.061,5.061,0,0,1,1,55.153v.056a5.149,5.149,0,0,0,4.106,5.036,5.115,5.115,0,0,1-1.344.169,4.532,4.532,0,0,1-.97-.088A5.174,5.174,0,0,0,7.581,63.9a10.3,10.3,0,0,1-6.355,2.186A9.6,9.6,0,0,1,0,66.012a14.429,14.429,0,0,0,7.862,2.3A14.487,14.487,0,0,0,22.45,53.728c0-.227-.008-.445-.019-.662A10.225,10.225,0,0,0,25,50.4Z",
    transform: "translate(0 -48)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.9e5b70fd40fdd032cb1e57f65aadac4a.svg";
export { ForwardRef as ReactComponent };